import React from 'react';
import { Box, Grid } from '@mui/material';
import ReviewsList from './ReviewsList';
import RatingList from './RatingList';
import OutputRatingPanel from 'components/SparkRuns/sparkRunOutput/OutputRatingPanel';
import type { JoinedSparks } from 'types/Spark/JoinedSpark';
import { InfoCard } from 'sharedComponents/UI';

type ReviewsTabProps = {
  spark: JoinedSparks;
};
function ReviewsTab({ spark }: ReviewsTabProps) {
  const sparkID = spark.id;
  const numberOfRatings = spark.meta.numberOfRatings;
  const isAllowedToReview = spark.meta.user.permissions?.canReview || false;

  return (
    <Box sx={{ paddingTop: '8px' }}>
      {!numberOfRatings ? (
        <InfoCard info='This Spark has not yet been rated' />
      ) : (
        <Grid item container flexDirection='column' xs={12}>
          <Grid item alignItems='center' xs={12}>
            <Box
              sx={{
                mb: 2,
                maxHeight: 500,
                mt: 0,
                boxShadow: 'none',
              }}
            >
              {isAllowedToReview ? (
                <Box mb={2}>
                  <OutputRatingPanel
                    sparkID={sparkID}
                    suggestion='Leave a rating or review for the community'
                    ShowCloseIcon={false}
                  />
                </Box>
              ) : (
                <></>
              )}
              <Box>
                <RatingList spark={spark} />
              </Box>
              <ReviewsList sparkID={sparkID} />
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}

export default ReviewsTab;
